import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'

import service from './service'


export default combineReducers({
  service,
  loadingBar:loadingBarReducer
  })